<template>
    <ListenerAlbumDetails v-if="isListenerMobile" />
    <AlbumDetails v-else />
</template>

<script>
import AlbumDetails from './AlbumDetails.vue'
import ListenerAlbumDetails from './ListenerAlbumDetails.vue'

export default {
    name: 'AlbumDetailsEntry',
    components: {
        AlbumDetails,
        ListenerAlbumDetails
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
